// @flow

import React, {Component} from 'react'

import css from './Collapsible.css'

type Props = {
  children?: any,
  title: string,
}
type State = {
  isCollapsed: boolean,
}
class Collapsible extends Component {
  props: Props

  state: State = {
    isCollapsed: true,
  }

  toggle = () => {
    const {isCollapsed} = this.state
    this.setState({isCollapsed: !isCollapsed})
  }

  render () {
    const {children, title} = this.props
    const {isCollapsed} = this.state
    return(
      <div className={css.component}>
        <div className={isCollapsed ? css.title : css.titleOpen} onClick={() => this.toggle()}>
          <p>{title}</p>
        </div>
        {!isCollapsed && (
          <div className={css.content}>
            {children}
          </div>
        )}
      </div>
    )
  }
}

export default Collapsible



// WEBPACK FOOTER //
// ./src/admin/components/Collapsible.js